// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiUrl: 'https://dit.netzary.com',
  // apiUrl: 'http://139.162.39.143:3006',
  // apiUrl: 'https://139.162.39.143',
  // apiUrl: 'https://ticket.netzary.com',
  // apiUrl: 'http://139.162.29.70:3009',
  // apiUrl: 'https://demo.centiyent.com',
  //  apiUrl: 'https://demo.ritreev.com',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
